var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var BenefitTypeIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 56,
    glyphHeight: 56
  }), React.createElement("path", {
    d: "M42.6087 0.869507C35.7217 0.869507 30.0869 6.50429 30.0869 13.3912C30.0869 20.2782 35.7217 25.913 42.6087 25.913C49.4956 25.913 55.1304 20.2782 55.1304 13.3912C55.1304 6.50429 49.4956 0.869507 42.6087 0.869507ZM40.5217 19.6521L34.2609 13.3912L36.3478 11.3043L40.5217 15.4782L48.8696 7.13038L50.9565 9.21733L40.5217 19.6521Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M13.3913 0.869507C6.50435 0.869507 0.869568 6.50429 0.869568 13.3912C0.869568 20.2782 6.50435 25.913 13.3913 25.913C20.2783 25.913 25.913 20.2782 25.913 13.3912C25.913 6.50429 20.2783 0.869507 13.3913 0.869507ZM13.3913 22.7826C8.17392 22.7826 4 18.6086 4 13.3912C4 8.17386 8.17392 3.99994 13.3913 3.99994C15.8957 3.99994 18.4 5.04342 20.0696 6.71299L11.3044 15.4782L7.13044 11.3043L5.04348 13.3912L11.3044 19.6521L21.7391 9.21733C22.3652 10.4695 22.7826 11.9304 22.7826 13.3912C22.7826 18.6086 18.6087 22.7826 13.3913 22.7826Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M13.3913 30.0869C6.50435 30.0869 0.869568 35.7217 0.869568 42.6087C0.869568 49.4956 6.50435 55.1304 13.3913 55.1304C20.2783 55.1304 25.913 49.4956 25.913 42.6087C25.913 35.7217 20.2783 30.0869 13.3913 30.0869ZM13.3913 52C8.17392 52 4 47.826 4 42.6087C4 37.3913 8.17392 33.2173 13.3913 33.2173C15.8957 33.2173 18.4 34.2608 20.0696 35.9304L11.3044 44.6956L7.13044 40.5217L5.04348 42.6087L11.3044 48.8695L21.7391 38.4347C22.3652 39.6869 22.7826 41.1478 22.7826 42.6087C22.7826 47.826 18.6087 52 13.3913 52Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M42.6087 30.0869C35.7217 30.0869 30.0869 35.7217 30.0869 42.6087C30.0869 49.4956 35.7217 55.1304 42.6087 55.1304C49.4956 55.1304 55.1304 49.4956 55.1304 42.6087C55.1304 35.7217 49.4956 30.0869 42.6087 30.0869ZM42.6087 52C37.3913 52 33.2174 47.826 33.2174 42.6087C33.2174 37.3913 37.3913 33.2173 42.6087 33.2173C45.113 33.2173 47.6174 34.2608 49.2869 35.9304L40.5217 44.6956L36.3478 40.5217L34.2609 42.6087L40.5217 48.8695L50.9565 38.4347C51.5826 39.6869 52 41.1478 52 42.6087C52 47.826 47.8261 52 42.6087 52Z",
    fill: "black"
  }));
};
export var BenefitTypeIconGlyph = function (props) {
  return React.createElement(BenefitTypeIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};